import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import * as styles from './styles.css';

export interface IShowMoreBtnProps {
  onClick(): void;
  loading?: boolean;
}

export const ShowMoreBtn: React.FC<IShowMoreBtnProps> = props => {
  const { onClick, loading } = props;

  return (
    <div className={styles['container']}>
      <Button theme="fill_secondary" size="M" onClick={onClick} fullWidth disabled={loading}>
        Показать еще
      </Button>
    </div>
  );
};

ShowMoreBtn.displayName = 'ShowMoreBtn';
